var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import { DataView } from 'primereact/dataview';
const Dataview = (_a) => {
    var { onScroll } = _a, rest = __rest(_a, ["onScroll"]);
    const viewBody = useRef(null);
    return (React.createElement("div", { ref: viewBody, className: "data-view-body", onScroll: onScroll },
        React.createElement(DataView, Object.assign({}, rest))));
};
export default Dataview;
